import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { TimeField } from '.';
import moment from 'moment';
import cx from 'classnames';
import CSSModules from 'react-css-modules';
import 'react-datepicker/dist/react-datepicker.css';
import style from './date-picker.scss';

@CSSModules(style, { allowMultiple: true })
export default class DatePicker extends Component {
  state = {
    selectedDate: null
  };

  static contextTypes = {
    onChange: PropTypes.func,
    getFormValue: PropTypes.func
  };

  static defaultProps = {
    size: 'default'
  };

  handleChange(date) {
    if (this.props.withTime) {
      date = date.toISOString();
    } else {
      date = date.format('YYYY-MM-DD');
    }

    if (this.context.onChange) {
      this.context.onChange(this.props.name, date);
    }

    if (this.props.onChange) {
      this.props.onChange(date);
    }

    this.setState({ selectedDate: date });
  }

  handleTimeChange(time) {
    if (this.value)
      this.handleChange(moment(this.value).hour(0).minutes(0).seconds(0).add('seconds', time));
  }

  get name() {
    return this.props.name || this.context.formFieldName;
  }

  get value() {
    if (this.context.getFormValue) {
      return this.context.getFormValue(this.name);
    } else {
      return (this.props.value || this.state.selectedDate);
    }
  }

  render() {
    const { withTime, size } = this.props;

    const rootStyleName = cx({
      root: true,
      [`size-${size}`]: true
    });

    return (
      <div styleName={rootStyleName} style={{ width: '100%' }}>
        <ReactDatePicker
          onChange={::this.handleChange}
          selected={(this.value && moment(this.value)) || undefined}
          placeholderText={this.props.placeholderText}
          style={{ width: '100%' }}
        />
        {withTime ? (
          <span>
            &nbsp;&nbsp;
            <TimeField
              onChange={::this.handleTimeChange}
              value={this.value && moment(this.value).diff(moment(this.value).hour(0).minutes(0).seconds(0), 'seconds')}
            />
          </span>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/date-picker.js